var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "video" },
    [
      _vm._t("titre"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "video-container" },
        [
          _c("transition", { attrs: { name: "fade" } }, [
            !_vm.play
              ? _c(
                  "div",
                  {
                    staticClass: "img-back",
                    style: "background-image: url(" + _vm.imgurl + ")",
                    on: { click: _vm.startVideo },
                  },
                  [
                    _vm.showPlayLogo
                      ? _c("span", { staticClass: "icon-play-video" })
                      : _c("div", { staticClass: "lds-ring" }, [
                          _c("div"),
                          _vm._v(" "),
                          _c("div"),
                          _vm._v(" "),
                          _c("div"),
                          _vm._v(" "),
                          _c("div"),
                        ]),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm._t("video"),
        ],
        2
      ),
      _vm._v(" "),
      _c("p", { staticClass: "legende" }, [_vm._t("legende")], 2),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }